module.exports = __webpack_public_path__ + "img/Slide1.44f5b183.png";